export const priceFormatter = (priceCents) => {
  return priceCents ? (priceCents * 0.01).toFixed(2) : (0 * 0.01).toFixed(2);
};
